<template>
    <button class="header__popup-toggle mr-spc12" data-popup-toggle="">
        <svg class="popup-phone" width="30" height="32" viewBox="0 0 30 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28 0H13C12.4696 0 11.9609 0.21071 11.5858 0.58579C11.2107 0.96086 11 1.46957 11 2V18C11 18 15.7586 15.4309 16.333 15H28C28.5304 15 29.0391 14.7893 29.4142 14.4142C29.7893 14.0391 30 13.5304 30 13V2C30 1.46957 29.7893 0.96086 29.4142 0.58579C29.0391 0.21071 28.5304 0 28 0ZM20 11H15V9H20V11ZM26 6H15V4H26V6Z" fill="#FF4A00"></path>
            <path d="M17 17V27C17 27.2652 16.8946 27.5196 16.7071 27.7071C16.5196 27.8946 16.2652 28 16 28H5C4.7348 28 4.2929 27.7071 4.2929 27.7071C4.1054 27.5196 4 27 4 27V7C4 6.7348 4.1054 6.4804 4.2929 6.2929C4.4804 6.1054 4.7348 6 5 6H9V2H3C2.2044 2 1.4413 2.31607 0.87868 2.87868C0.31607 3.4413 0 4.2044 0 5V29C0 29.7956 0.31607 30.5587 0.87868 31.1213C1.4413 31.6839 2.2044 32 3 32H18C18.7956 32 19.5587 31.6839 20.1213 31.1213C20.6839 30.5587 21 29.7956 21 29V17H17Z" fill="#111111"></path>
        </svg>
    </button>
</template>

<script>
    export default {
        name: "PopupPhone"
    }
</script>

<style scoped>

</style>